import Vue from 'vue'

import manage from "../manage.serve"//管理的接口的
import chat from "../chat.serve"//聊天相关接口

const apis = {
  manage,
  chat
}
export default {
  install() {
    Vue.prototype.$apis = apis
  }
}
